<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{ data.nzTitle }}</p>
	</div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
		@if (scraps && scraps.length > 0) {
		<nz-table #basicTable [nzData]="scraps" class="m-0 p-0" nzSize="small" nzTableLayout="auto" [nzBordered]="true"
			[nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }">
			<thead>
				<tr>
					<th nzWidth="80px">Fecha</th>
					<th nzWidth="120px">Artículo</th>
					<th nzWidth="120px">Razón</th>
					<th nzWidth="120px">Causa</th>
					<th nzWidth="120px">Cantidad</th>
					<th nzWidth="180px">Observaciones</th>
					<th nzWidth="120px">Operario</th>
				</tr>
			</thead>
			<tbody>
				@for (scrap of basicTable.data; track data) {
				<tr>
					<td>
						{{
						scrap.createdAt === null
						? "-"
						: (scrap.createdAt | date: "dd/MM/YYYY HH:mm:ss")
						}}
					</td>
					<td>
						{{ scrap.finalProduct?.article?.name + (scrap.finalProduct?.articleBatch ? ('-' +
						scrap.finalProduct?.articleBatch?.batchNumber) : '' )}}
					</td>
					<td>{{ scrap.scrapCause?.text }}</td>
					<td>{{ scrap.scrapReason?.text }}</td>
					<td class="text-right">
						{{ scrap.units | number:'1.0-2' }} {{ getDisplayUnit() }}
					</td>
					<td>{{ scrap.observations }}</td>
					<td>{{ scrap.createdBy?.name }}</td>
				</tr>
				}
			</tbody>
		</nz-table>
		}
		@else {
		<div class="w-full h-full content-center">
			<nz-empty></nz-empty>
		</div>
		}
	}
</div>

<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button">
			Cerrar
		</button>
	</div>
</div>
